export default __webpack_public_path__ + "static/media/cone_grey.5f81b68a.png";